import { DashboardPage } from '@apps-common/apps/portal/pages/dashboard/Index'

export const Dashboard = () => <DashboardPage />
